import { deleteContactsFromList } from '@/apis/lists';
import { microfrontendURLPrefix } from '@/config';
import { useSaladBar } from '@australiangreens/ag-internal-components';
import { useAuth0 } from '@auth0/auth0-react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router';

export function useDeleteContactsFromList(listId: number) {
  const queryClient = useQueryClient();
  const { getAccessTokenSilently } = useAuth0();
  const { enqueueSuccessNotification } = useSaladBar();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: async (contactIds: number[]) => {
      const token = await getAccessTokenSilently();
      return deleteContactsFromList(token, listId, contactIds);
    },
    onSuccess: (data) => {
      const { listDeleted, count } = data;
      queryClient.invalidateQueries({ queryKey: ['list', listId] });
      let countStr = 'contacts';
      if (count !== undefined) {
        countStr = count === 1 ? '1 contact' : `${count} contacts`;
      }

      if (listDeleted !== undefined && listDeleted) {
        enqueueSuccessNotification(`Successfully deleted ${countStr} from list and list deleted`);
        navigate(`${microfrontendURLPrefix}/lists`);
      } else {
        enqueueSuccessNotification(`Successfully deleted ${countStr} from list`);
      }
    },
  });
}
